import { type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useThemeStore } from '../store/themeStore';

interface LayoutProps {
  children?: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { isDarkMode } = useThemeStore();

  return (
    <div className={isDarkMode ? 'dark' : ''}>
      <div className="min-h-screen bg-navy-50 dark:bg-navy-950 transition-colors duration-300">
        <Sidebar />
        <div className="lg:pl-64">
          <main className="max-w-7xl mx-auto px-4 py-6 pl-20">
            {children || <Outlet />}
          </main>
        </div>
      </div>
    </div>
  );
}
